module.exports = __webpack_public_path__ + "static/media/avatar20.38beff58.png";